<div class="card-body" >
    <div class="row pad-tb-10">
        <div class="col-md-10">
            <span class="fnt-21">Verify Your Previous Payment History and Proceed for Payment  </span>
        </div>
       
        <!-- <div class="col-md-2 align-right">
            <button class="btn btn-primary" (click)="bcakfn()"> Back </button>
        </div> -->
    </div>

    <div class="row pad-tb-10">
        <div class="col-md-6">
            Name: {{itiHeaderName}} <br>
            ITI Code: {{itiHeaderCode}} <br>    
        </div>
        <div class="col-md-6">
            Email: {{itiHeaderemail}} <br>
            Mobile: {{itiHeaderMobile}} <br>    
        </div>
    </div>
    <div class="example-container mat-elevation-z8">
        <mat-table #table [dataSource]="dataSource_Master" #sort_Master="matSort" matSort>

            <ng-container matColumnDef="slno">
                <mat-header-cell *matHeaderCellDef mat-sort-header> # </mat-header-cell>
                <mat-cell *matCellDef="let element; let i = index;"> {{i+1}} </mat-cell>
            </ng-container>

            <!-- Position Column -->
            <!-- <ng-container matColumnDef="iticode">
                <mat-header-cell *matHeaderCellDef mat-sort-header> ITI Code </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.iticode}} </mat-cell>
            </ng-container>
 -->
            <!-- <ng-container matColumnDef="itiname">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Name    </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.itiname}} </mat-cell>
            </ng-container> -->

            <!-- <ng-container matColumnDef="itiemail">
                <mat-header-cell *matHeaderCellDef mat-sort-header>  Email </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.itiemail}} </mat-cell>
            </ng-container> -->

            <!-- Position Column -->
            <!-- <ng-container matColumnDef="itimobile">
                <mat-header-cell *matHeaderCellDef mat-sort-header>  Mobile </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.itimobile}} </mat-cell>
            </ng-container>
 -->
            <!-- <ng-container matColumnDef="statename">
                <mat-header-cell *matHeaderCellDef mat-sort-header> State  </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.statename}} </mat-cell>
            </ng-container> -->

            <!-- Position Column -->
            <!-- <ng-container matColumnDef="districtname">
                <mat-header-cell *matHeaderCellDef mat-sort-header> District </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.districtname}} </mat-cell>
            </ng-container> -->

            <ng-container matColumnDef="payrefid">
                <mat-header-cell *matHeaderCellDef mat-sort-header> PayRefID    </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.payrefid}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="payrefdate">
                <mat-header-cell *matHeaderCellDef mat-sort-header> PayRefDate </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.payrefdate}} </mat-cell>
            </ng-container>

            <!-- Position Column -->
            <ng-container matColumnDef="noofstu">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Students </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.noofstu}} <button class="btn btn-success small-btn" (click)="selected_family_member_Master.select(element)" (click)="payMasterView()">View</button> </mat-cell>
            </ng-container>

            <ng-container matColumnDef="amount">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Amount    </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.amount}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="ccaveref">
                <mat-header-cell *matHeaderCellDef mat-sort-header> CCRefNo </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.ccaveref}} </mat-cell>
            </ng-container>

            <!-- Position Column -->
            <ng-container matColumnDef="paymentdate">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Payment Date </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.paymentdate}} </mat-cell>
            </ng-container>                

              <!-- Position Column -->
              <ng-container matColumnDef="pstatus">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
                <mat-cell *matCellDef="let element"> 
                    <button class="btn btn-success small-btn" *ngIf="element.pstatus == ''" (click)="selected_family_member_Master.select(element)"  (click)="payMaster()"> {{element.pstatus }}Pay</button>
                    

                    <!-- <button class="btn btn-danger small-btn" *ngIf="element.pstatus == ''" (click)="selected_family_member_Master.select(element)"  (click)="payMasterCancel()"> Cancel </button> -->
                    <span class="btn btn-success small-btn"  *ngIf="element.pstatus == 'DONE' ">PAID</span>
                    <span class="btn btn-primary small-btn" *ngIf="element.pstatus == 'pending'">Pending</span>
                    </mat-cell>
            </ng-container>       

            <!-- Position Column -->
            <!-- <ng-container matColumnDef="upload">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Upload </mat-header-cell>
                <mat-cell *matCellDef="let element"> 
                    <button class="btn btn-success small-btn"*ngIf="element.pstatus == 'DONE'" (click)="selected_family_member_Master.select(element)"  (click)="reverseApi()">Upload to NCVT MIS </button>
                    

                    </mat-cell>
            </ng-container>    -->

            <mat-header-row *matHeaderRowDef="displayedColumnsMaster"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumnsMaster;  let i = index"></mat-row>

        </mat-table>


        <!-- <mat-paginator #paginator_Master="matPaginator"  [length]="totallength_master" [pageSizeOptions]="[ 5,10, 25]"></mat-paginator> -->


    </div>

</div>